module.exports = __webpack_public_path__ + "static/media/snes.a5c5d320.png";